import { getQfbenefit } from "@/services/user/user";
import appStore from "@/stores/appStore";
import { Message } from "@arco-design/web-react";
import Qfsdk from "@bytedance-ad/fuwu-sdk";
import { useEffect, useRef } from "react";

const useQfService = () => {
  const qfsdkRef = useRef<Qfsdk | null>(null);

  const keys = [
    {
      id: "benefit_1_3000",
      name: "合成视频点数（3000点）",
      desc: "适用于合成视频/图文，以及解析视频等功能点数消耗",
    },
    {
      id: "benefit_3_1024",
      name: "云存储（1T）",
      desc: "云存储可使用的空间大小",
    },
  ];

  useEffect(() => {
    if (!appStore.isInFrame) return;
    console.log("qfsdkRef.current", qfsdkRef.current);

    if (!qfsdkRef.current) {
      qfsdkRef.current = new Qfsdk({
        appId: "1821950568141840",
        requests: {
          checkFuncsAvailable: (data) => {
            console.log("init=----------------", data);
            return Promise.resolve(
              keys.map((item) => ({
                code: 1,
                funcKey: item.id,
                msg: "ok",
              }))
            );
          },
        },
      });
    }

    return () => {
      qfsdkRef.current?.destroy();
    };
  }, []);

  //   qfsdkRef.current
  //     .checkFuncsAvailable({ funcKeys: ["benefit_1_3000", "benefit_3_1024"] })
  //     .then((res) => {
  //       console.log("checkFuncsAvailable", res);
  //     });

  const invokePayModal = async (key) => {
    if (!appStore.isInFrame) return;
    const res = await qfsdkRef.current.openAppPaidFeature({ funcKey: key });
    console.log("openAppPaidFeature", res);
    if (res.code === 0) {
      await getQfbenefit();
      Message.info("权益购买成功，到账可能略有延迟，请刷新页面查看");
    }
  };

  return {
    invokePayModal,
    keys,
  };
};

export default useQfService;
